import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableUpdateThemeError, RpcObservableUpdateThemeKey,
    RpcObservableUpdateThemeRequest, RpcObservableUpdateThemeResult
} from './rpc-observable-update-theme-model';

export class RpcObservableUpdateThemeClient
    extends RpcObservableClient<RpcObservableUpdateThemeRequest,
    RpcObservableUpdateThemeResult, RpcObservableUpdateThemeError> {

    /**
     * Initializes a new instane of RpcObservableUpdateThemeClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableUpdateThemeKey.command, RpcObservableUpdateThemeKey.version);
    }

    /**
     * The update theme command.
     *
     * @param request the Rpc update theme object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableUpdateThemeResult> the observable object.
     */
    public updateTheme(request: RpcObservableUpdateThemeRequest, outbound?: RpcOutbound): Observable<RpcObservableUpdateThemeResult> {
        return this.observableCall(request, outbound);
    }
}
